<template>
  <div class="pages-service">
    <div class="the-banner"></div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module1-conts">
          <div class="module-title">
            <span class="title-cn">神行者技术支持服务</span>
            <span class="title-en">TECHNICAL SUPPORT SERVICES</span>
          </div>
          <div class="module-view">
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:6}">
              <div class="item-box wow slideInLeft">
                <div class="item">
                  <div class="conts">
                    <img :src="require('@/assets/images/service-module1-1.png')" />
                    <p>神行者客服热线</p>
                    <p>400-048-1488</p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:6}">
              <div class="item-box wow slideInUp">
                <div class="item">
                  <div class="conts">
                    <img :src="require('@/assets/images/service-module1-0.png')" />
                    <p style="line-height:24px;">技术服务热线</p>
                    <p style="font-size:14px;line-height:16px;">17749677601</p>
                    <p style="font-size:14px;line-height:16px;">17352860203</p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:6}">
              <div class="item-box wow slideInUp">
                <div class="item">
                  <div class="conts">
                    <img :src="require('@/assets/images/service-module1-2.png')" />
                    <p>神行者技术论坛</p>
                    <p><a href="http://bbs.xspeeder.com/" target="_blank">bbs.xspeeder.com</a></p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:6}">
              <div class="item-box wow slideInRight">
                <div class="item">
                  <div class="conts">
                    <img :src="require('@/assets/images/service-module1-3.png')" />
                    <p>官方技术交流群</p>
                    <p>180247499</p>
                  </div>
                </div>                
              </div>
            </el-col>
          </div>
          <div class="title">
            <span>技术联系方式：</span>
          </div>
          <div class="contact-box">
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}" :xl="{span:8}">
              <div class="item-box wow slideInLeft">
                <div class="item">
                  <div class="conts">
                    <div class="name">
                      <img :src="require('@/assets/images/service-module1-4.png')" />
                      <p>技术 彭工</p>
                    </div>
                    <div class="style">
                      <p><a target="_blank" href="tencent://message/?uin=460526494&amp;Menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:460526494:51" alt="点击这里给我发消息" title="点击这里给我发消息"/></a></p>
                      <p><img :src="require('@/assets/images/service-module1-5.png')" /></p>
                    </div>
                    <div class="code">
                      <img :src="require('@/assets/images/service-QRcord-pjl.jpg')" />
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}" :xl="{span:8}">
              <div class="item-box wow slideInUp">
                <div class="item">
                  <div class="conts">
                    <div class="name">
                      <img :src="require('@/assets/images/service-module1-4.png')" />
                      <p>技术 胡工</p>
                    </div>
                    <div class="style">
                      <p><a target="_blank" href="tencent://message/?uin=3003565082&amp;Menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:3003565082:51" alt="点击这里给我发消息" title="点击这里给我发消息"/></a></p>
                      <p><img :src="require('@/assets/images/service-module1-5.png')" /></p>
                    </div>
                    <div class="code">
                      <img :src="require('@/assets/images/service-QRcord-hq.jpg')" />
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}" :xl="{span:8}">
              <div class="item-box wow slideInRight">
                <div class="item">
                  <div class="conts">
                    <div class="name">
                      <img :src="require('@/assets/images/service-module1-4.png')" />
                      <p>技术 张工</p>
                    </div>
                    <div class="style">
                      <p><a target="_blank" href="tencent://message/?uin=492290949&amp;Menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:492290949:51" alt="点击这里给我发消息" title="点击这里给我发消息"/></a></p>
                      <p><img :src="require('@/assets/images/service-module1-5.png')" /></p>
                    </div>
                    <div class="code">
                      <img :src="require('@/assets/images/service-QRcord-zx.jpg')" />
                    </div>
                  </div>
                </div>
              </div>
            </el-col>

            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}" :xl="{span:8}">
              <div class="item-box wow slideInLeft">
                <div class="item">
                  <div class="conts">
                    <div class="name">
                      <img :src="require('@/assets/images/service-module1-4.png')" />
                      <p>技术 赵工</p>
                    </div>
                    <div class="style">
                      <p><a target="_blank" href="tencent://message/?uin=3003519739&amp;Menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:3003519739:51" alt="点击这里给我发消息" title="点击这里给我发消息"/></a></p>
                      <p><img :src="require('@/assets/images/service-module1-5.png')" /></p>
                    </div>
                    <div class="code">
                      <img :src="require('@/assets/images/service-QRcord-zl.jpg')" />
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}" :xl="{span:8}">
              <div class="item-box wow slideInUp">
                <div class="item">
                  <div class="conts">
                    <div class="name">
                      <img :src="require('@/assets/images/service-module1-4.png')" />
                      <p>技术 宾工</p>
                    </div>
                    <div class="style">
                      <p><a target="_blank" href="tencent://message/?uin=3003596499&amp;Menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:3003596499:51" alt="点击这里给我发消息" title="点击这里给我发消息"/></a></p>
                      <p><img :src="require('@/assets/images/service-module1-5.png')" /></p>
                    </div>
                    <div class="code">
                      <img :src="require('@/assets/images/service-QRcord-bz.jpg')" />
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}" :xl="{span:8}">
              <div class="item-box wow slideInRight">
                <div class="item">
                  <div class="conts">
                    <div class="name">
                      <img :src="require('@/assets/images/service-module1-4.png')" />
                      <p>技术 费工</p>
                    </div>
                    <div class="style">
                      <p><a target="_blank" href="tencent://message/?uin=3003492167&amp;Menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:3003492167:51" alt="点击这里给我发消息" title="点击这里给我发消息"/></a></p>
                      <p><img :src="require('@/assets/images/service-module1-5.png')" /></p>
                    </div>
                    <div class="code">
                      <img :src="require('@/assets/images/service-QRcord-fyq.jpg')" />
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </div>
        </div>
      </el-col>
    </div>
    <div class="module2-conts">
      <div class="header-box">
        <div class="module-title">
          <span class="title-cn">服务器售后返修标准</span>
          <span class="title-en">AFTER-SALES REPAIR STANDARD</span>
        </div>
        <div class="info-box">
          <div class="item">购物放心</div>
          <div class="item">送装放心</div>
          <div class="item">售后放心</div>
        </div>
      </div>
      <div class="bgbox-white">
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:12,offset:6}">
          <div class="conts-box">
            <div class="text-item">
              <h3>服务介绍</h3>
              <p class="line1">客户选购神行者的服务器等产品，将由神行者技术人员为客户提供安装调试服务，并做好完善的包装工作，客户可根据快递单号收到购买的产品。</p>
            </div>
            <div class="text-item">
              <h3>服务热线</h3>
              <p class="line1">400-048-1488</p>
            </div>
            <div class="text-item">
              <h3>服务范围</h3>
              <p class="line1">神行者对售出且在保修期内的产品提供返修服务，具体规则如下：</p>
              <div class="img-box">
                <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:8}">
                  <img :src="require('@/assets/images/service-module2-1.jpg')" />
                </el-col>
                <el-col :xs="{span:12}" :sm="{span:8}" :md="{span:8}" :lg="{span:8}">
                  <img :src="require('@/assets/images/service-module2-2.jpg')" />
                </el-col>
                <el-col :xs="{span:12}" :sm="{span:8}" :md="{span:8}" :lg="{span:8}">
                  <img :src="require('@/assets/images/service-module2-3.jpg')" />
                </el-col>
              </div>
              <p class="line2">注意事项：</p>
              <p class="line2">* 退换范围：机箱外观没有刮痕，没有撞损，机箱内硬件没有人为物损、人为烧毁，机箱外壳没有刮伤、撞伤痕迹。</p>
              <p class="line2">* 免费保修定义：人为物损及火灾、洪水、雷电损坏除外。</p>
              <p class="line2">* 送修产生的运费，神行者和客户各自承担快递发出的费用，恕不接受到付邮件。</p>
            </div>
            <div class="text-item">
              <h3>服务响应</h3>
              <p class="line1">送修服务：自确认有保修义务时起，3-5个工作日内解决。</p>
              <p class="line1">电话服务：自确认有保修义务时起，1小时内回应，1~2个工作日内给出解决方案。</p>
            </div>
            <div class="text-item">
              <h3>服务承诺</h3>
              <p class="line1">自购买日起（以我司出货日期，产品序列号），在保修期内产品发生正常使用、维护故障，经我司检测属实，神行者予以免费保修。因人为或不可抗力引起的损坏，神行者有权拒绝保修。</p>
              <div class="table-box">
                <table border="0" cellspacing="0" cellpadding="0" align="center">
                  <thead>
                    <tr>
                      <th>产品型号</th>
                      <th>质保时间</th>
                      <th>更换承诺</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>路由设备（XN、运营商系列）</td>
                      <td>质保三年</td>
                      <td rowspan='7'>15天内更换</td>
                    </tr>
                    <tr>
                      <td>路由设备（XS系列）</td>
                      <td rowspan='6'>质保一年</td>
                    </tr>
                    <tr>
                      <td>智能桌面服务器整机</td>
                    </tr>
                    <tr>
                      <td>智能桌面机顶盒</td>
                    </tr>
                    <tr>
                      <td>融合网关</td>
                    </tr>
                    <tr>
                      <td>无线AP</td>
                    </tr>
                    <tr>
                      <td>服务器配件（网卡、硬盘等）</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="text-item">
              <h3>产品更换条例</h3>
              <p class="line1">产品更换如出现以下情形之一，神行者有权拒绝更换。</p>
              <div class="img-box">
                <el-col :xs="{span:24}" :sm="{span:6}" :md="{span:6}" :lg="{span:6}">
                  <img :src="require('@/assets/images/service-module2-4.png')" />
                  <p class="img-info">产品外观有明显刮痕</p>
                </el-col>
                <el-col :xs="{span:24}" :sm="{span:6}" :md="{span:6}" :lg="{span:6}">
                  <img :src="require('@/assets/images/service-module2-5.png')" />
                  <p class="img-info">机顶盒有拆卸痕迹</p>
                </el-col>
                <el-col :xs="{span:24}" :sm="{span:6}" :md="{span:6}" :lg="{span:6}">
                  <img :src="require('@/assets/images/service-module2-6.png')" />
                  <p class="img-info">条形码缺失或不匹配</p>
                </el-col>
                <el-col :xs="{span:24}" :sm="{span:6}" :md="{span:6}" :lg="{span:6}">
                  <img :src="require('@/assets/images/service-module2-7.png')" />
                  <p class="img-info">产品烧毁或芯片颗粒脱落</p>
                </el-col>
              </div>
            </div>
            <div class="text-item">
              <h3>返修说明</h3>
              <p class="line1">1、机箱及其附件、CPU散热风扇、SATA串口数据线、SAS一拖四数据线、随机附件（包装材料、电源线等）不在保修范围之内，不予保修。</p>
              <p class="line1">2、更换的部件可能是同型号产品，也可能是性能上等同于原型号的部件。</p>
              <p class="line1">3、经我司售后维修及更换后的整机（部件）保修期限按原整机（部件）保修期限计算。</p>
              <div class="img-box">
                <img class="img-8" :src="require('@/assets/images/service-module2-8.png')" />
              </div>
              <p class="line2">* 注：市场缺货或者停产导致该返修产品不能在返修周期内返还的，售后将采取更换其他同性能产品的方案解决。</p>
            </div>
            <div class="text-item">
              <h3>客户须知</h3>
              <p class="line1">1、客户在收到我司产品后，请检查是否存在产品物损，如发现产品型号、数量异常，请在24小时内与我司售后（400-048-1488）联系，我司将与保险公司或运输部门联系解决，否则一律视为客户自身原因引起的物损。</p>
              <p class="line1">2、对于因下列原因导致的服务器故障，我公司不承担免费保修义务：</p>
              <p class="line3"><img :src="require('@/assets/images/service-module2-icon2.png')" />客户擅自拆开整机配件所造成的机器故障或部件损坏。</p>
              <p class="line3"><img :src="require('@/assets/images/service-module2-icon3.png')" />由于火灾、洪水、雷电、地震等不可抗力引起的机器故障或部件损坏。</p>
              <p class="line3"><img :src="require('@/assets/images/service-module2-icon4.png')" />服务器在非产品规定的工作环境下（温度、湿度、电压、电流、机器内部清洁度）使用，引起的机器故障或部件损坏。</p>
              <p class="line3"><img :src="require('@/assets/images/service-module2-icon5.png')" />由于保养不当（如病毒感染、进水、挤压等）造成的机器故障或部件损坏。</p>
              <p class="line3"><img :src="require('@/assets/images/service-module2-icon6.png')" />因使用盗版操作系统或软件引起的问题，或因使用自编软件或非公开发行的软件造成的机器不能正常工作。</p>
              <p class="line1">3、客户要求先发、或者对发返修产品，按照产品全额价格付款到我司，以作为押金，在我司收到返修产品确认无物损和产品故障问题后，押金予以返还。如发现物损，按第2条处理，产生维修费用相对从押金中扣除。</p>
            </div>
            <div class="text-item">
              <h3>退换货制度</h3>
              <p class="line1">凡在我司购买之产品，如出现质量问题，我司承诺：7天无理由退货，15天无理由换货。</p>
              <div class="img-box">
                <img class="img-8" :src="require('@/assets/images/service-module2-9.png')" />
              </div>
            </div>
            <div class="text-item">
              <h3>温馨提示</h3>
              <p class="line1">易耗性产品（线材、CPU风扇、风墙风扇）、明示赠送产品或特价产品等（全新产品及在售产品除外）不属于我司退货范围。</p>
            </div>
          </div>
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.the-banner {
  height: 400px;
  background-image: url("../../assets/images/service-banner1.jpg");
  background-repeat: no-repeat;
  background-position: center;
}
.bgbox-white{
  padding: 50px 10px;
  overflow: hidden;
  background: #fff;
  box-sizing: border-box;
}
.module-title{
  text-align: center;
  padding-bottom: 40px;
  .title-cn{
    display: block;
    font-size: 30px;
    font-weight: bold;
    color: #1f1f1f;
  }
  .title-en{
    display: block;
    font-size: 12px;
    font-weight: 400;
    color: #757575;
    line-height: 20px;
  }
}

.module1-conts{
  .module-view{
    overflow: hidden;
    .item-box{
      max-width: 400px;
      margin: 0 auto;
      padding: 10px;
      box-sizing: border-box;
      .item{
        border: 1px solid #e6e6e6;
        height: 200px;
        position: relative;
        .conts{
          position: absolute;
          height: 56px;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          img{
            display: block;
            float: left;
          }
          p{
            font-size: 18px;
            color: #1f1f1f;
            white-space: nowrap;
            line-height: 28px;
            padding-left: 70px;
            box-sizing: border-box;
            a{
              color: #1f1f1f;
              &:hover{
                color: #0066cc;
                border-bottom: 1px solid #0066cc;
              }
            }
          }
        }
      }
    }
  }
  .title{
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    color: #1f1f1f;
    font-weight: bold;
  }
  .contact-box{
    width: 100%;
    overflow: hidden;
    .item-box{
      max-width: 400px;
      margin: 0 auto;
      padding: 10px;
      box-sizing: border-box;
      .item{
        border: 1px solid #e6e6e6;
        height: 140px;
        position: relative;
        .conts{
          width: 300px;
          height: 90px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
          padding: 0 10px;
          box-sizing: border-box;
          .name{
            width: 80px;
            height: 100%;
            float: left;
            text-align: center;
            p{
              font-size: 14px;
              color: #1f1f1f;
            }
          }
          .style{
            width: 100px;
            height: 100%;
            float: left;
            padding-top: 15px;
            text-align: center;
            box-sizing: border-box;
            p{
              line-height: 30px;
              img{
                width: 80px;
              }
            }
          }
          .code{
            width: 90px;
            height: 100%;
            float: right;
            border: 1px solid #e6e6e6;
            box-sizing: border-box;
            img{
              display: block;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width:1200px) and (max-width:1550px){
  .module1-conts{
    .module-view{
      .item-box{
        .item{
          .conts{
            img{
              display: none;
            }
            p{
              padding-left: 0;
              text-align: center;
            }
          }
        }
      }
    }
  }
}

.module2-conts{
  .header-box{
    width: 100%;
    height: 230px;
    background: url("../../assets/images/service-module2bg.jpg") no-repeat;
    background-position: center center;
    .module-title{
      padding-top: 50px;
      padding-bottom: 30px;
      .title-cn{
        color: #fff;
      }
      .title-en{
        color: #fff;
      }
    }
    .info-box{
      width: 300px;
      height: 40px;
      background: #fff;
      border-radius: 40px;
      margin: 0 auto;
      padding-top: 8px;
      box-sizing: border-box;
      .item{
        width: 100px;
        height: 24px;
        float: left;
        padding-left: 36px;
        box-sizing: border-box;
        font-size: 14px;
        color: #1f1f1f;
        line-height: 24px;
        background: url("../../assets/images/service-module2-icon1.png") no-repeat;
        background-size: 24px;
        background-position: 6px center;
      }
    }
  }
  .conts-box{
    width: 100%;
    .text-item{
      margin-bottom: 60px;
      h3{
        font-size: 22px;
        color: #1f1f1f;
        margin-bottom: 25px;
        line-height: 30px;
      }
      .line1{
        font-size: 16px;
        color: #4c4c4c;
        margin-bottom: 10px;
        line-height: 30px;
      }
      .line2{
        font-size: 14px;
        color: #787878;
      }
      .line3{
        line-height: 24px;
        color: #0066cc;
        padding-left: 10px;
        margin-bottom: 10px;
        box-sizing: border-box;
        img{
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
      }
      .img-box{
        overflow: hidden;
        padding: 40px 0;
        img{
          display: block;
          margin: 0 auto;
          &.img-8{
            width: 100%;
            max-width: 730px;
          }
        }
        .img-info{
          font-size: 14px;
          color: #0066cc;
          text-align: center;
        }
      }
      .table-box {
        width: 100%;
        overflow-x: scroll;
        padding-top: 40px;
        padding-bottom: 5px;
        box-sizing: border-box;
        table {
          width: 100%;
          border-right: 1px solid #333;
          border-bottom: 1px solid #333;
          border-spacing: 0;
          border-collapse: collapse;
          box-sizing: border-box;
          th {
            font-weight: 700;
            min-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #333;
            border-top: 1px solid #333;
            height: 30px;
            background: #fff;
            font-size: 16px;
            color: #333;
            text-align: center;
            box-sizing: border-box;
            padding: 5px!important;
          }
          td {
            font-weight: 400;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #333;
            border-top: 1px solid #333;
            height: 30px;
            background: #fff;
            font-size: 14px;
            color: #333;
            text-align: center;
            box-sizing: border-box;
            padding: 5px!important;
          }
        }
        &::-webkit-scrollbar {
          width: 6px;
          height: 6px
        }
        &::-webkit-scrollbar-thumb {
          background-color: #999;
          border-radius: 6px
        }
      }
    }
  }
}


// 移动端css
@media screen and (max-width: 767px) {
  .the-banner{
    height: 260px;
    background-image: url("../../assets/images/service-banner2.jpg");
  }
  .module1-conts{
    .module-view{
      .item-box{
        padding: 10px 0;
      }
    }
    .contact-box{
      .item-box{
        padding: 10px 0;
      }
    }
  }
}

</style> 
